// extracted by mini-css-extract-plugin
export default {"headingRow":"NumberedHeading_headingRow__g2r3U","numberWrap":"NumberedHeading_numberWrap__9jKyl","number":"NumberedHeading_number__VzD-c","title":"NumberedHeading_title__YFxLb"};